<template lang="">
    <v-container>
       <v-card flat class="mt-15">
        <v-card-text class="text-center black--text headline">
          Click the link below to go to the enrolment page.
        </v-card-text>
        <v-card-text class="text-center blue--text headline">
            <a target="_blank" href="https://form.bondibasc.com/">https://form.bondibasc.com/</a>
        </v-card-text>
        <v-card-text class="text-center black--text headline">
            Then select 'Enrol' to begin a new enrolment or edit an existing one.
          </v-card-text>
       </v-card>
        
    </v-container>
</template>
<script>
export default {
    
}
</script>